export default __webpack_public_path__ + "static/media/schoolRegi.ac5a70c4.png";